import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../../Common/Icon';

const BILLING_CARDS = [
  {
    id: 'monthly',
    icon: 'sprout',
    title: 'Believer',
    price: '$9/mo',
    outcome: 'Use AI Coach for guided reflection.',
    description: 'Believer adds AI Coach, Think, Timeline, and 50 guided requests per day.',
    cta: 'Choose Believer',
    action: 'believer'
  },
  {
    id: 'guardian',
    icon: 'leaf',
    title: 'Guardian',
    price: '$25/mo',
    outcome: 'Review deeper patterns and signal briefs.',
    description: 'Everything in Believer plus Results, 500 guided requests per day, and signal briefs.',
    cta: 'Choose Guardian',
    action: 'guardian'
  },
  {
    id: 'lifetime',
    icon: 'users',
    title: 'Lifetime',
    price: '$299',
    outcome: 'Own the private desktop app.',
    description: 'Desktop app, local-first data, manual sync, encrypted backups, local AI support, and offline access.',
    cta: 'Own Lifetime',
    action: 'lifetime',
    featured: true
  }
];

const LandingPricing = React.memo(({
  onSignup,
  onUpgradeBeliever,
  onUpgradeGuardian,
  onUpgradeLifetime,
  isAuthenticated = false,
  checkoutPendingTier = ''
}) => {
  const handlers = {
    believer: onUpgradeBeliever,
    guardian: onUpgradeGuardian,
    lifetime: onUpgradeLifetime
  };

  return (
    <section id="plans" className="landing-pricing-section">
      <div className="landing-template-frame landing-pricing-frame">
        <div className="landing-pricing-copy">
          <h2>Start free. Add guidance or Desktop when it fits.</h2>
          <p className="landing-sr-only">Start the loop.</p>
          <button type="button" className="landing-btn landing-btn--ghost landing-pricing-free" onClick={onSignup}>
            Start the loop free
          </button>
        </div>

        <div className="landing-pricing-options">
          {BILLING_CARDS.map((plan) => {
            const isPending = checkoutPendingTier === plan.action;
            return (
              <article key={plan.id} className={`landing-pricing-card ${plan.featured ? 'is-featured' : ''}`}>
                {plan.featured && <span className="landing-pricing-badge">Best value</span>}
                <span className="landing-pricing-icon">
                  <Icon name={plan.icon} size={20} />
                </span>
                <h3>{plan.title}</h3>
                <strong>{plan.price}</strong>
                <p className="landing-plan-outcome">{plan.outcome}</p>
                <p>{plan.description}</p>
                <button
                  type="button"
                  className="landing-pricing-card-button"
                  onClick={handlers[plan.action]}
                  disabled={Boolean(checkoutPendingTier)}
                >
                  {isPending ? 'Opening checkout...' : plan.cta}
                </button>
              </article>
            );
          })}
        </div>

        <p className="landing-pricing-note">
          {isAuthenticated
            ? 'Paid plans open secure checkout in this tab. If handoff is interrupted, return to ThryveLoop and tier sync will recover in the background.'
            : 'Create a free account first, then continue to secure checkout for paid plans.'}
        </p>
      </div>
    </section>
  );
});

LandingPricing.propTypes = {
  onSignup: PropTypes.func.isRequired,
  onUpgradeBeliever: PropTypes.func,
  onUpgradeGuardian: PropTypes.func,
  onUpgradeLifetime: PropTypes.func,
  onGetDesktopApp: PropTypes.func,
  isAuthenticated: PropTypes.bool,
  checkoutPendingTier: PropTypes.string,
};

LandingPricing.displayName = 'LandingPricing';

export default LandingPricing;
